export const lastNameSubstring = (lastName: string) => {
  return lastName
    .split(`${lastName.includes('-') ? '-' : ' '}`)
    .map(sub => sub.substring(0, 1))
    .join()
    .replace(',', '-')
}
